import { API_URL } from 'constants/api';
import { getIsNativePlatform } from 'utils/client/mobile';

/** Native bundles have no Next API routes; browsers use their current app origin. */
export function contentApiUrl(path: string): string {
  if (process.env.TARGET_PLATFORM === 'MOBILE') {
    const origin = process.env.REMOTE_API_URL;
    if (!origin) throw new Error('REMOTE_API_URL is required for MOBILE editorial delivery');
    return `${origin.replace(/\/$/, '')}/api/content/${path}`;
  }
  return `${getIsNativePlatform() ? API_URL : '/api'}/content/${path}`;
}
